/* New Maybach templates only. Recompute availability after native BFCache return.
   Never force-enable a variant: the existing V2 selector remains authoritative. */
(() => {
  if (window.__maybachMtoRecoveryInstalled) return;
  window.__maybachMtoRecoveryInstalled = true;
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-maybach-mto]').forEach((root) => {
      const selected = root.querySelector('[data-option-index] [data-option-value].is-selected:not(:disabled)');
      if (selected) selected.click();
    });
  });
})();
